import React, { useEffect } from 'react';
import { CheckStatus } from '@components/SiteUserUpload/types/uploadTypes';
import { FileProcessingStatusLine } from '@components/SiteUserUpload/Components/FileProcessingStatus';
import { Spinner } from '@dynamika-shared/ui/Spinner/Spinner';
import {
  PolingResponse,
  UploadStatus,
  VerificationStepsItem,
} from 'src/store-redux/siteUpload/siteUploadStore.types';

export interface UploadValidationStepProps {
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
  setFile: (file: File | null) => void;
  setDisableConfirmUpload: (value: boolean) => void;
  setVerificationStepsData: (steps?: Partial<VerificationStepsItem>[]) => void;
  verificationStepsData: Partial<VerificationStepsItem>[] | undefined;
  polingData: PolingResponse | null | undefined;
  setStatus: (status: UploadStatus) => void;
}

export const UploadValidationStep: React.FC<UploadValidationStepProps> = ({
  setVerificationStepsData,
  verificationStepsData,
  setDisableConfirmUpload,
  polingData,
  setCurrentStep,
  setFile,
  setStatus,
}) => {
  useEffect(() => {
    setDisableConfirmUpload(
      !verificationStepsData?.every(step => step.status !== CheckStatus.WARNING)
    );
  }, [setDisableConfirmUpload, verificationStepsData]);

  if (!polingData) {
    return (
      <div className='flex h-full w-full items-center justify-center'>
        <Spinner spinCircleColor='#F26E23' spinColor='#FFF6F0' />
      </div>
    );
  }

  const handleReupload = () => {
    setStatus(UploadStatus.INITIAL_VIEW);
    setFile(null);
    setCurrentStep(2);
  };

  return (
    <div
      className='flex w-full flex-col justify-between rounded-[8px] border-pastelBlue px-1 py-2'
      data-testid='UploadCheckTable'
    >
      <div className='rounded-2xl bg-pageBackgroundWhite px-2 py-1.5'>
        <p className='text-1824 font-medium text-chineseBlack '>
          Validation Results
        </p>
      </div>

      {polingData?.verificationSteps.map(statusOption => {
        return (
          <FileProcessingStatusLine
            key={statusOption.id}
            statusOption={statusOption}
            setVerificationStepsData={setVerificationStepsData}
            verificationStepsData={verificationStepsData}
            setDisableConfirmUpload={setDisableConfirmUpload}
            handleReupload={handleReupload}
          />
        );
      })}
    </div>
  );
};
